var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.categories)?_c('div',{class:{
    showNavbar: _vm.isNavbar && _vm.hasNavbarOpened && !_vm.multipleServices,
    showNavbarWithServices: _vm.isNavbar && _vm.hasNavbarOpened && _vm.multipleServices,
    hideNavbar: !_vm.isNavbar && _vm.hasNavbarOpened && !_vm.multipleServices,
    hideNavbarWithServices: !_vm.isNavbar && _vm.hasNavbarOpened && _vm.multipleServices
  },attrs:{"id":"categories-navbar"}},_vm._l((_vm.categories),function(category){return _c('HorizontalCategory',{key:category.id,attrs:{"category":category}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }